<template>
	<div>
		<mt-header :title="title" style="position: fixed;top:0;left: 0;width: 100%;z-index: 999;">
			<div slot="left">
				<mt-button icon="back" @click="goback()">返回</mt-button>
			</div>
			<mt-button slot="right">
				<mt-button v-if="!UserName"  @click='loginBtn()'>登录</mt-button>
				<mt-button v-if="UserName"  @click='sheetVisiblefun()'>个人中心</mt-button>
			</mt-button>
		</mt-header>
		<div style="height: 40px;"></div>
		<mt-actionsheet :actions="actions" v-model="sheetVisible">
		</mt-actionsheet>
		<router-view></router-view>
	</div>
</template>

<script>
	import {
		Actionsheet
	} from 'mint-ui';

	export default {
		data() {
			return {
				actions: [{
					name: '个人信息',
					method: this.gotocenter
				}, {
					name: '退出登录',
					method: this.outlogin
				}],
				sheetVisible: false,
				UserName: '',
				title: '',
				path: '/login',
			}
		},
		created() {
			this.title = this.$route.name
			var competition_info = localStorage.getItem('competition_info') ? JSON.parse(localStorage.getItem(
				'competition_info')) : '';
			var competition_cookie =  localStorage.getItem('competition_cookie')
			if (competition_info&&competition_cookie) {
				this.UserName = competition_info.UserName
				if (this.$route.path == '/mycenter' || this.$route.path == '/myteam') {
					this.UserName = '修改'
				}
			}else{
				this.UserName = ''
			}
		},
		watch: {
			$route(to, from) {
				this.title = this.$route.name
				var competition_info = localStorage.getItem('competition_info') ? JSON.parse(localStorage.getItem(
					'competition_info')) : '';
				var competition_cookie =  localStorage.getItem('competition_cookie')
				if (competition_info&&competition_cookie) {
					this.UserName = competition_info.UserName
					if (this.$route.path == '/mycenter' || this.$route.path == '/myteam') {
						this.UserName = '修改'
					}
				}else{
					this.UserName = ''
				}
			},
			sheetVisible(){
				console.log(this.UserName)
				if(this.UserName == '修改'){
					this.actions = [{
						name: '修改信息',
						method: this.gotoeditcenter
					}, {
						name: '退出登录',
						method: this.outlogin
					}]
				}else{
					this.actions = [{
						name: '个人信息',
						method: this.gotocenter
					}, {
						name: '退出登录',
						method: this.outlogin
					}]
				}
			}
		},
		methods: {
			sheetVisiblefun() {
				this.sheetVisible = !this.sheetVisible
			},
			loginBtn() {
				this.$router.push('/login')
			},
			selfBtn() {

				this.$router.push(this.path)
			},
			goback(){
				this.$router.go(-1)
			},
			gotocenter() {
				this.$router.push('/mycenter')
			},
			gotoeditcenter(){this.$router.push('/editMyCenter')},
			outlogin(){
				localStorage.removeItem("competition_cookie")
				localStorage.removeItem("competition_info")
				window.history.go(0)
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/index.vue